<template>
  <v-container :class="containerClass" fluid>
    <employee-form mode="add" @cancel="onCancel">
      <template #header>
        <div class="d-flex align-center">
          <v-btn
            icon
            color="primary"
            class="mr-2"
            :href="$route('employees.index')"
          >
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <h2>Create new user</h2>
        </div>
      </template>
    </employee-form>
  </v-container>
</template>
<script>
import LayoutDashboard from '@layouts/Dashboard'
import EmployeeForm from '@components/Employee/Form'
export default {
  components: {
    EmployeeForm,
  },
  layout: LayoutDashboard,
  methods: {
    onCancel() {
      window.location.href = this.$route('employees.index')
    },
  },
}
</script>
